import { AppConfig } from '@dh-io-emh/config-types';
import { createHttpService } from '../utils/http.util';

export type B2xCosApi = ReturnType<typeof createB2xCosApi>;

// B2X customer address type is not defined in b2x/authentication-library or in api.schema
export type B2xB2cProfile = {
  address: B2xCustomerAddress;
  dateOfBirth?: string;
  email: string;
  firstName: string;
  landlinePhone?: string;
  lastName: string;
  mobilePhoneNumber?: string;
  salutation?: string;
};

export type B2xB2bProfile = {
  address: B2xCustomerAddress;
  invoiceAddress: B2xCustomerAddress;
  legalType: string;
  name: string;
  vatId: string;
};

export type B2xCustomerAddress = {
  addressLine1?: string;
  addressLine2?: string;
  addressLine3?: string;
  city?: string;
  countryCode?: string;
  doorNo?: string;
  floorNo?: string;
  houseName?: string;
  state?: string;
  streetName?: string;
  streetNumber?: string;
  streetType?: string;
  province?: string;
  postalCode?: string;
  postOfficeBox?: string;
};

export type B2xCustomerAddresses = {
  user: B2xB2cProfile;
  companies?: B2xB2bProfile[];
};

export const createB2xCosApi = ({ config: { b2xCosApiUrl, lang } }: { config: AppConfig }) => {
  const http = createHttpService({
    url: b2xCosApiUrl,
  });

  return {
    getB2xCustomerAddresses: async (customerType: string): Promise<B2xCustomerAddresses> => {
      const { data } = await http.get<B2xCustomerAddresses>(`customer-addresses`, {
        params: { country_code: lang, businessType: customerType },
      });

      return data;
    },
  };
};
